module.exports = "dist/e31fcf1885e371e19f5786c2bdfeae1b.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Bold.ttf
// module id = 222
// module chunks = 0